import React, { useState, useRef, useEffect } from 'react';

const AccountMenu = ({ user, onEditProfile, onChangePassword, onLogout }) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const onDocClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('click', onDocClick);
    return () => document.removeEventListener('click', onDocClick);
  }, []);

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="px-3 py-1 text-sm bg-gray-100 text-gray-700 rounded hover:bg-gray-200 transition-colors"
        aria-haspopup="true"
        aria-expanded={open}
      >
        Account
        <span className="ml-1">▾</span>
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-44 bg-white border border-gray-200 rounded shadow-lg z-10">
          <div className="px-3 py-2 text-xs text-gray-500 border-b border-gray-100">
            {user?.username}
          </div>
          <button
            onClick={() => { setOpen(false); onEditProfile?.(); }}
            className="w-full text-left px-3 py-2 text-sm hover:bg-gray-50"
          >
            Edit profile
          </button>
          <button
            onClick={() => { setOpen(false); onChangePassword?.(); }}
            className="w-full text-left px-3 py-2 text-sm hover:bg-gray-50"
          >
            Change password
          </button>
          <button
            onClick={() => { setOpen(false); onLogout?.(); }}
            className="w-full text-left px-3 py-2 text-sm text-red-600 hover:bg-red-50 border-t border-gray-100"
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default AccountMenu;


